import { useTranslation } from 'react-i18next'
import { Group, Paper, Stack, Text } from '@mantine/core'

export default function CommentPosts({ posts }) {
  const { t, i18n } = useTranslation()
  return posts.length === 0 ? <Text size="sm" c="dimmed">{t("Geen berichten in dit gesprek.")}</Text> : posts.map(post => <Paper key={post.id} withBorder p="sm"><Stack gap="xs">
    <Group justify="space-between"><Text size="sm" fw={600}>{post.author}</Text>{post.date && <Text size="xs" c="dimmed">{new Date(post.date).toLocaleString(i18n.language)}{post.edited ? t(" · Bewerkt") : ''}</Text>}</Group>
    <Text size="sm" c={post.deleted ? 'dimmed' : undefined} style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{post.text || t("Leeg bericht")}</Text>
  </Stack></Paper>)
}
